module.exports = __webpack_public_path__ + "media/images/svg/facebook-5aa9dd97f0c1a5039ca6a864cf0a609c.svg";